import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LocalizationModel} from "../../system/languages/localization.model";

@Component({
  selector: 'app-help-contents',
  templateUrl: './help-contents.component.html',
  styles: [
  ]
})
export class HelpContentsComponent implements OnInit {
  @Input() selectedId: string;
  @Input() topics: LocalizationModel[];
  newTopic: string;
  @Output() onAddTopic: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  addTopic() {
    this.newTopic = this.newTopic?.trim();
    if (this.newTopic?.length > 2) {
      this.onAddTopic.emit(this.newTopic);
      this.newTopic = '';
    }
  }
}
